import styled from 'styled-components';

export const Section = styled.section`
  background: ${({ theme }) => theme.colors.bgSurface};
  padding: ${({ theme }) => theme.spacing[16]} ${({ theme }) => theme.spacing[8]};

  @media (max-width: 768px) {
    padding: ${({ theme }) => theme.spacing[10]} ${({ theme }) => theme.spacing[4]};
  }
`;

export const Container = styled.div`
  max-width: 640px;
  margin: 0 auto;
`;

export const Title = styled.h2`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: clamp(1.75rem, 4vw, 2.5rem);
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ theme }) => theme.colors.textPrimary};
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing[10]};
`;

export const Item = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray200};
`;

export const Question = styled.button`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing[4]};
  padding: ${({ theme }) => theme.spacing[4]} 0;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  font-size: ${({ theme }) => theme.fontSizes.base};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.fonts.sans};
  transition: color ${({ theme }) => theme.transitions.fast};

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const Toggle = styled.span<{ $open: boolean }>`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  transition: transform ${({ theme }) => theme.transitions.base};
  transform: ${({ $open }) => ($open ? 'rotate(45deg)' : 'rotate(0deg)')};
  color: ${({ theme }) => theme.colors.primary};
`;

export const Answer = styled.div<{ $open: boolean }>`
  overflow: hidden;
  max-height: ${({ $open }) => ($open ? '400px' : '0')};
  transition: max-height ${({ theme }) => theme.transitions.slow};
`;

export const AnswerText = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.base};
  color: ${({ theme }) => theme.colors.textSecondary};
  line-height: ${({ theme }) => theme.lineHeights.relaxed};
  padding-bottom: ${({ theme }) => theme.spacing[4]};
`;
